import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16">
      <div className="card-surface p-10 max-w-lg w-full text-center" data-testid="payment-cancel-root">
        <div className="w-12 h-12 mx-auto flex items-center justify-center bg-rose-600/20 mb-4">
          <X size={24} className="text-rose-500" />
        </div>
        <h1 className="font-display text-3xl mb-2">Checkout cancelled.</h1>
        <p className="text-sm text-zinc-400 mb-6">
          No worries — nothing was charged. Come back when you're ready to top up the vault.
        </p>
        <div className="flex items-center gap-3 justify-center">
          <Link to="/coins">
            <Button className="btn-crimson rounded-none px-6">Back to Coin Store</Button>
          </Link>
          <Link to="/feed" className="text-sm text-zinc-500 hover:text-white transition-colors">
            Back to feed
          </Link>
        </div>
      </div>
    </div>
  );
}
